import React, { useState } from 'react';
import Modal from 'react-modal';
import { ActionLink } from 'components/shared';
import { translate } from 'javascripts/translations/i18n';

import onePerPage from 'images/print-1-per-page.jpg';
import twoPerPage from 'images/print-2-per-page.jpg';
import fourPerPage from 'images/print-4-per-page.jpg';
import tenPerPage from 'images/print-10-per-page.jpg';

import { Button } from '@companycam/slab-web';

type PrintModalProps = {
  photos: number[];
  isOpen: boolean;
  onRequestClose: () => void;
};

const PrintModal = ({ photos, isOpen, onRequestClose }: PrintModalProps) => {
  const [perPage, setPerPage] = useState(1);
  const [printDetails, setPrintDetails] = useState(true);

  const printPhotos = () => {
    const params = new URLSearchParams({
      per_page: `${perPage}`,
      include_metadata: `${printDetails}`,
    });
    photos.forEach((photo) => params.append('image_ids[]', `${photo}`));
    window.location.href = `/print?${params}`;
  };

  const toggleOff = translate('common.toggleOff');
  const toggleOn = translate('common.toggleOn');

  return (
    <Modal
      isOpen={isOpen}
      ariaHideApp={false}
      onRequestClose={onRequestClose}
      contentLabel={translate('photos.printModal.modalTitlePrintPhotos')}
      overlayClassName="modal"
      className="modal-content-wrap"
    >
      <ActionLink className="modal-close-button" onClick={onRequestClose}>
        <i className="mdi mdi-close" />
      </ActionLink>
      <h3 className="modal-title">
        {translate('photos.printModal.modalTitlePrintPhotos')}
      </h3>
      <form>
        <div className="print-options-on-off">
          <ul className="tg-list">
            <li className="tg-list-item">
              <input
                className="tgl tgl-light"
                id="print_details"
                type="checkbox"
                checked={printDetails}
                onChange={(e) => {
                  setPrintDetails(e.target.checked);
                }}
              />
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label
                htmlFor="print_details"
                className="tgl-btn"
                data-off-label={toggleOff}
                data-on-label={toggleOn}
              />
            </li>
            <li className="left-align-instructions">
              {translate('photos.printModal.instructions')}{' '}
            </li>
          </ul>
        </div>
        <div className="print-options">
          <div
            className={perPage === 1 ? 'print-option selected' : 'print-option'}
          >
            <div className="option-title">
              {translate('photos.printModal.1perpage')}
            </div>
            <div
              className="option-graphic"
              onClick={() => {
                setPerPage(1);
              }}
            >
              <img src={onePerPage} alt="Print 1 Per Page" />
            </div>
          </div>
          <div
            className={perPage === 2 ? 'print-option selected' : 'print-option'}
          >
            <div className="option-title">
              {translate('photos.printModal.2perpage')}{' '}
            </div>
            <div
              className="option-graphic"
              onClick={() => {
                setPerPage(2);
              }}
            >
              <img src={twoPerPage} alt="Print 2 Per Page" />
            </div>
          </div>

          <div
            className={perPage === 4 ? 'print-option selected' : 'print-option'}
          >
            <div className="option-title">
              {translate('photos.printModal.4perpage')}{' '}
            </div>
            <div
              className="option-graphic"
              onClick={() => {
                setPerPage(4);
              }}
            >
              <img src={fourPerPage} alt="Print 4 Per Page" />
            </div>
          </div>

          <div
            className={
              perPage === 10 ? 'print-option selected' : 'print-option'
            }
          >
            <div className="option-title">
              {translate('photos.printModal.10perpage')}{' '}
            </div>
            <div
              className="option-graphic"
              onClick={() => {
                setPerPage(10);
              }}
            >
              <img src={tenPerPage} alt="Print 10 Per Page" />
            </div>
          </div>
        </div>
        <div className="btn-container full">
          <Button color="primary" onClick={printPhotos}>
            {translate('photos.printModal.printPhotos')}{' '}
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default PrintModal;
